import { render, staticRenderFns } from "./RefreshInputData.vue?vue&type=template&id=55b3f550"
import script from "./RefreshInputData.vue?vue&type=script&lang=ts"
export * from "./RefreshInputData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports